/* Day One Careers navigation: mirrors the website header script */
(function () {
    const toggle = document.querySelector('.review-menu-toggle');
    const menu = document.getElementById('review-menu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
        menu.classList.toggle('is-open', open);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.review-nav-group[open]').forEach(function (group) {
            group.open = false;
        });
        if (toggle.getAttribute('aria-expanded') === 'true') {
            toggle.click();
            toggle.focus();
        }
    });

    document.addEventListener('click', function (event) {
        document.querySelectorAll('.review-nav-group[open]').forEach(function (group) {
            if (!group.contains(event.target)) group.open = false;
        });
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Day One Careers free resources popup */
(function () {
    const popup = document.getElementById('d1c-resource-popup');
    const onTasterPage = /^\/taster\/?$/.test(window.location.pathname) || /^\/free-stuff\/?$/.test(window.location.pathname);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sessionKey = 'd1c-resource-popup-session';
    const dismissalKey = 'd1c-resource-popup-dismissed-at';
    const dismissalPeriod = 7 * 24 * 60 * 60 * 1000;
    let opener;
    let timer;
    let shown = false;

    if (!popup || onTasterPage || storageAvailable(sessionKey) || recentlyDismissed()) return;

    const dialog = popup.querySelector('.d1c-resource-popup__dialog');
    const closeControls = popup.querySelectorAll('[data-resource-popup-close]');
    const cta = popup.querySelector('[data-resource-popup-cta]');

    function storageAvailable(key) {
        try {
            return window.sessionStorage.getItem(key) === 'shown';
        } catch (error) {
            return false;
        }
    }

    function recentlyDismissed() {
        try {
            const dismissedAt = Number(window.localStorage.getItem(dismissalKey));
            return dismissedAt && Date.now() - dismissedAt < dismissalPeriod;
        } catch (error) {
            return false;
        }
    }

    function remember(key, value) {
        try {
            window[key === dismissalKey ? 'localStorage' : 'sessionStorage'].setItem(key, value);
        } catch (error) {
            // Storage is optional; the popup remains functional when it is unavailable.
        }
    }

    function removeTriggers() {
        window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExitIntent);
    }

    function getFocusableElements() {
        return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    }

    function trapFocus(event) {
        if (event.key !== 'Tab') return;

        const focusable = getFocusableElements();
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!first || !last) {
            event.preventDefault();
            dialog.focus();
        } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    function closePopup() {
        if (!shown) return;

        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('d1c-resource-popup-open');
        document.removeEventListener('keydown', onKeydown);
        remember(dismissalKey, String(Date.now()));
        window.setTimeout(function () {
            popup.hidden = true;
        }, reducedMotion ? 0 : 180);
        if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function onKeydown(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            closePopup();
            return;
        }
        trapFocus(event);
    }

    function showPopup() {
        if (shown) return;

        shown = true;
        removeTriggers();
        remember(sessionKey, 'shown');
        opener = document.activeElement;
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('d1c-resource-popup-open');
        window.requestAnimationFrame(function () {
            popup.classList.add('is-visible');
        });
        document.addEventListener('keydown', onKeydown);
        const closeButton = popup.querySelector('[data-resource-popup-close]');
        window.setTimeout(function () {
            closeButton.focus();
        }, reducedMotion ? 0 : 180);
    }

    function onScroll() {
        const availableScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (availableScroll > 0 && window.scrollY / availableScroll >= 0.3) showPopup();
    }

    function onExitIntent(event) {
        if (event.relatedTarget === null && event.clientY <= 10) showPopup();
    }

    closeControls.forEach(function (control) {
        control.addEventListener('click', closePopup);
    });
    cta.addEventListener('click', function () {
        remember(dismissalKey, String(Date.now()));
    });

    timer = window.setTimeout(showPopup, 10000);
    window.addEventListener('scroll', onScroll, {passive: true});
    if (window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', onExitIntent);
    }
})();
